import { render, staticRenderFns } from "./LoadsActions.vue?vue&type=template&id=22a08b44"
import script from "./LoadsActions.vue?vue&type=script&lang=js"
export * from "./LoadsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports